import { useEffect, useState } from 'react';

const CATALOG_IMAGES = [
  {
    url: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/d6eefab906a35bf6bcfeb5ab7ca42b09.jpeg',
    label: 'Portada — Productos Químicos para Perforación 2026',
  },
  {
    url: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/ff55cc5ec3c2c0648a4a3693ff8b773b.jpeg',
    label: 'ALFA INHIBIT® — Inhibidor de Arcillas-Lubricante',
  },
  {
    url: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/38660e468e52794d390af56f09342199.jpeg',
    label: 'POLY ALPHAS 7® — Inhibidor de Lutitas-Arcillas Reactivas',
  },
  {
    url: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/ab9dc577371a8582ccedf36424c7082c.jpeg',
    label: 'PX4-MO® — Surfactante Anti-Acreción de Crudos / Lubricante',
  },
  {
    url: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/191c6bf599cccfb13e107c2f23bb8567.jpeg',
    label: 'EZP-480® — Lubricante / Mejorador de la ROP',
  },
];

export default function CatalogSlider() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      goNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [current]);

  const goTo = (index: number) => {
    if (animating || index === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 300);
  };

  const goNext = () => {
    const next = (current + 1) % CATALOG_IMAGES.length;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(next);
      setAnimating(false);
    }, 300);
  };

  const goPrev = () => {
    const prev = (current - 1 + CATALOG_IMAGES.length) % CATALOG_IMAGES.length;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(prev);
      setAnimating(false);
    }, 300);
  };

  return (
    <section className="bg-white py-16 md:py-24 border-t border-neutral-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Header */}
        <div className="text-center mb-10">
          <span className="text-primary-600 text-sm font-600 tracking-widest uppercase mb-3 block">
            Catálogo Oficial
          </span>
          <h2 className="font-heading font-700 text-3xl md:text-4xl text-neutral-900 leading-tight mb-3">
            Catálogo de <span className="text-primary-400">Perforación 2026</span>
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-neutral-500 text-sm max-w-xl mx-auto mb-6">
            Fichas técnicas oficiales de nuestros productos para el área de perforación petrolera.
          </p>
          <a
            href="https://storage.readdy-site.link/project_files/757146f5-efbb-4393-a727-072a282aedee/b7b735ad-b915-4c41-8604-b7b00e01c7d7_PRODUCTOS-QUIMICOS-PARA-PERFORACION-2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download="PRODUCTOS-QUIMICOS-PARA-PERFORACION-2026.pdf"
            className="inline-flex items-center gap-2.5 px-6 py-3 rounded-xl bg-primary-500 hover:bg-primary-400 text-white text-sm font-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-pdf-line text-base"></i>
            Descargar Catálogo PDF Oficial
            <i className="ri-download-line text-base"></i>
          </a>
        </div>

        {/* Slider container */}
        <div className="flex flex-col lg:flex-row gap-8 items-center">

          {/* Main image */}
          <div className="relative w-full lg:flex-1 max-w-2xl mx-auto">
            {/* Frame */}
            <div className="relative bg-neutral-50 rounded-2xl border border-neutral-200 overflow-hidden shadow-lg"
              style={{ aspectRatio: '4/5', maxHeight: 680 }}
            >
              <img
                key={current}
                src={CATALOG_IMAGES[current].url}
                alt={CATALOG_IMAGES[current].label}
                className={`w-full h-full object-contain bg-white transition-all duration-300 ${
                  animating ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
                }`}
              />

              {/* Page counter badge */}
              <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm border border-neutral-200 rounded-full px-3 py-1.5 flex items-center gap-2 shadow-sm">
                <span className="text-neutral-900 text-xs font-700">{current + 1}</span>
                <span className="text-neutral-400 text-xs">/</span>
                <span className="text-neutral-500 text-xs">{CATALOG_IMAGES.length}</span>
              </div>

              {/* Prev / Next arrows */}
              <button
                onClick={goPrev}
                className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-primary-500 border border-neutral-200 hover:border-primary-500 rounded-full text-neutral-700 hover:text-white transition-all duration-200 cursor-pointer shadow-sm"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                onClick={goNext}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-primary-500 border border-neutral-200 hover:border-primary-500 rounded-full text-neutral-700 hover:text-white transition-all duration-200 cursor-pointer shadow-sm"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>

            {/* Label below image */}
            <p className="text-center text-neutral-500 text-sm mt-4 px-4">
              {CATALOG_IMAGES[current].label}
            </p>

            {/* Dot indicators */}
            <div className="flex justify-center gap-2 mt-4">
              {CATALOG_IMAGES.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className={`transition-all duration-300 rounded-full cursor-pointer ${
                    i === current
                      ? 'bg-primary-500 w-6 h-2'
                      : 'bg-neutral-300 hover:bg-neutral-400 w-2 h-2'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Thumbnail strip */}
          <div className="flex lg:flex-col gap-3 overflow-x-auto lg:overflow-x-visible lg:overflow-y-auto pb-2 lg:pb-0 lg:max-h-[680px] w-full lg:w-36 flex-shrink-0">
            {CATALOG_IMAGES.map((img, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                className={`flex-shrink-0 w-24 h-28 lg:w-full lg:h-28 rounded-xl overflow-hidden border-2 transition-all duration-200 cursor-pointer ${
                  i === current
                    ? 'border-primary-500 ring-2 ring-primary-500/20'
                    : 'border-neutral-200 hover:border-neutral-400 opacity-60 hover:opacity-90'
                }`}
              >
                <img
                  src={img.url}
                  alt={`Página ${i + 1}`}
                  className="w-full h-full object-contain bg-white"
                />
              </button>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}